import Image from 'next/image'
import studioGoldenLogo from './studiogolden.png'

type IconProps = {
  className?: string
}

const StudioGoldenLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={studioGoldenLogo} alt="Studio Golden Logo" height={48} {...attributes} />
}

export default StudioGoldenLogo
